import HomeImg from '~assets/home.svg';
import AppLogo from './assets/app_logo.svg';
import AppLogoInverse from './assets/app_logo_inverse.svg';
import { BASE, CSB, CUC } from './constants/colors';
import { WorkUnits } from './constants';

export const KHYMEI_TENANT_COLORS = {
  base: BASE,
  csb: CSB,
  cuc: CUC
};
export const khymei_settings: ImplementationSettings = {
  colors: KHYMEI_TENANT_COLORS.base,
  envs: {
    google_recaptcha: import.meta.env.VITE_RECAPTCHA_KEY,
    backend_url: import.meta.env.VITE_BACKEND_URL
  },
  logos: {
    logo_regular: AppLogo,
    logo_inverse: AppLogoInverse,
    landing: HomeImg
  },
  workUnits: WorkUnits
};
